<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_table_of_contents_1">To my husband, who stormed out of the room after his precious Georgia Bulldogs lost their game, too angry to bother turning off ESPN in the midst of his tantrum. Hours later, I noticed men’s professional beach volleyball on the screen and was instantly sucked into the hot, sandy action, thereby inspiring this story. Thanks, love!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?783291e2